export function getStoredUISetting(settingString:string) {
        const stateData = window.localStorage.getItem('storedUISettings-'+settingString);
        if (stateData == null)
            return undefined;

        const state = JSON.parse(stateData);
        return state[settingString];
}

export function setStoredUISetting(settingString:string, value:any) {
        const state = { [settingString]: value }
        window.localStorage.setItem('storedUISettings-'+settingString, JSON.stringify(state));
}

export function getUIAccessedLast(ui_uuid:string) {
        const stateData = window.localStorage.getItem('uiAccessedLast');
        if (stateData == null)
            return undefined;

        const state = JSON.parse(stateData);
        const timestring:string = state['timestamp'];
        return {uuid:state['uuid'], timestamp:new Date(timestring).getTime()};
}
export function setUIAccessedLast(ui_uuid:string) {
        const state = { ['timestamp']: Date.now(), ['uuid']:ui_uuid }
        window.localStorage.setItem('uiAccessedLast', JSON.stringify(state));
}
